import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { EntityPropValue } from './formFields/EntityPropValue';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';

export const EntityPropForm = () => {

  const { entityObj } = useEntityMgr();

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.propId.expr = ExprUtils.whereParams('entity', entityObj.entity);
    fieldToFieldDef.value.component = <EntityPropValue fieldDef={fieldToFieldDef.value} />
    return fieldToFieldDef;
  }

  return <EntityForm augFieldDefs={augFieldDefs} />
}